import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'toCode'})

export class ToCodePipe implements PipeTransform {

	constructor() {}

	transform(text: string, noUnderscores = false): string {

		const code = text ? text.trim().replace(/-/g, '*').replace(/[^\w\-]{1,}/g, (noUnderscores ? '' : '_')).toLowerCase() : '';

		return code;
	}
}
